<template>
  <div class="star-block">
    <table v-if="stars.length" id="stars">
      <caption class="caption">
        Star list table
      </caption>
      <tr class="header">
        <th scope="col">PLAN</th>
        <th scope="col">GROUP</th>
        <th scope="col">PROJECT</th>
        <th scope="col">{{ $t("plans.starBlock.table.launch") }}</th>
        <th scope="col">{{ $t("plans.starBlock.table.actions") }}</th>
      </tr>
      <tr v-for="(star, index) in stars" v-bind:key="index">
        <td>{{ star.planName }}</td>
        <td>
          <router-link class="link" v-bind:to="'/group/' + star.groupId">{{
            star.groupName
          }}</router-link>
        </td>
        <td>
          <router-link class="link" v-bind:to="'/project/' + star.projectId">{{
            star.projectName
          }}</router-link>
        </td>
        <td>
          <div
            class="launch"
            v-bind:class="{
              disabled: !(
                star.planEnabled &&
                star.groupEnabled &&
                star.projectEnabled
              ),
            }"
          >
            <span>{{ $t("plans.starBlock.button.launch") }}</span>
            <a
              v-if="
                star.planEnabled && star.groupEnabled && star.projectEnabled
              "
              class="cover"
              v-bind:href="
                '/project/' + star.projectId + '/analysis/module0002'
              "
            ></a>
          </div>
        </td>
        <td>
          <DeleteStar
            v-bind:projectId="star.projectId"
            v-bind:projectName="star.projectName"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import DeleteStar from "@/components/plans/DeleteStar.vue";

export default {
  name: "Star",
  props: ["stars"],
  components: {
    DeleteStar,
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  margin-top: 17px;
  border-collapse: collapse;
  .caption {
    display: none;
  }
}

tr.header {
  color: $text-light;
  background: $primary;
  th {
    text-align: left;
    border: none;
    padding: 7px 0 7px 28px;
  }
}

td {
  text-align: left;
  background: $surface-alpha;
  border-bottom: 2px solid $surface-beta;
  padding: 10px 0 10px 28px;
}

.launch {
  width: 200px;
  border-radius: 15px;
  background: $primary url("../../assets/icons/plans-launch-group.png")
    no-repeat 15px center;
  background-size: 30px;
  color: $text-light;
  padding: 10px 20px 10px 60px;
  position: relative;

  &.disabled {
    background-color: $border-beta;
    pointer-events: none;
  }

  a.cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.link {
  background: url("../../assets/icons/link.png") no-repeat right;
  padding: 0 25px 0 0;
}
</style>
